import { mui } from '@local/finsera-core/src/libs';

import { SECTION_BG, TABLE_HIGHLIGHT_BG, TABLE_ROW_HEIGHT } from '../../theme/layout-size';

export const finDataGridSx = (props: mui.dataGrid.DataGridPremiumProps) => {
  const columnHeaderHeight = props.columnHeaderHeight || TABLE_ROW_HEIGHT.md; //45;
  return {
    fontSize: '12px',

    '& .MuiDataGrid-root': {
      fontSize: '12px !important',
      border: '0!important',
    },

    '& .MuiDataGrid-row:nth-child(even)': {
      backgroundColor: `${SECTION_BG}`,
    },

    '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-hovered': {
      backgroundColor: `${TABLE_HIGHLIGHT_BG} !important`,
    },

    // Make aggregated values bold in footer (totals at bottom)
    '& .MuiDataGrid-footerCell': {
      fontWeight: 500,
    },

    // Make aggregated values in grouped rows bold
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-row:has(.MuiDataGrid-groupingCriteriaCell) .MuiDataGrid-cell:not(.MuiDataGrid-groupingCriteriaCell)':
      {
        fontWeight: 500,
      },

    '& .MuiDataGrid-groupingCriteriaCell': {
      height: '100%',
      minHeight: 'unset',
      maxHeight: '100%',
    },

    '& .MuiDataGrid-groupingCriteriaCellToggle': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '& .data-grid-default .MuiDataGrid-withBorderColor': {
      borderColor: 'hsl(202, 10%, 94%) !important',
    },

    '& .data-grid-default .MuiDataGrid-columnHeader': {
      background: '#f2f5f7 !important',
      borderColor: 'hsl(202, 10%, 88%) !important',
      borderBottom: '1px solid hsl(202, 10%, 88%) !important',
      borderTop: '1px solid hsl(202, 10%, 88%) !important',
    },

    '& .data-grid-default .MuiDataGrid-columnHeaderTitleContainerContent': {
      fontSize: '11px',
      letterSpacing: 0,
    },

    '& .data-grid-default .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus': {
      outline: '0 !important',
    },

    '& .data-grid-default .MuiDataGrid-iconButtonContainer .MuiButtonBase-root': {
      padding: '1px',
    },

    '& .data-grid-default .MuiDataGrid-columnHeaderTitle': {
      fontWeight: '500 !important',
      lineHeight: '13.5px !important',
      letterSpacing: '-0.5px',
    },

    '& .data-grid-default .MuiDataGrid-pinnedColumnHeaders': {
      boxShadow: '0 5px 5px rgba(0, 0, 0, 0.15)',
    },

    '& .data-grid-default .MuiDataGrid-pinnedColumns': {
      background: '#fff',
      borderTop: '1px solid hsl(202, 10%, 88%)',
      boxShadow: '0 5px 5px rgba(0, 0, 0, 0.15)',
    },

    '& .data-grid-index-header': {
      background: '#DBE6F0 !important',
    },

    '& .MuiDataGrid-panelWrapper': {
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
      paddingTop: '0.7rem',
    },

    // Make pinned rows (often used for totals) bold
    '& .MuiDataGrid-pinnedRows .MuiDataGrid-cell': {
      fontWeight: 500,
    },

    // Make aggregation column values bold
    '& .MuiDataGrid-cell--withAggregation': {
      fontWeight: 500,
    },

    '& .MuiDataGrid-columnHeaders': {
      height: `${columnHeaderHeight}px`,
    },

    '& .MuiDataGrid-columnHeader': {
      height: `${columnHeaderHeight}px`,
      background: '#f2f5f7',
      color: '#646679!important',
      display: 'flex',
      justifyContent: 'space-between !important',
    },

    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: '600 !important',
    },

    '& .MuiDataGrid-menuIcon': {
      marginRight: '-5px !important',
    },

    '& .MuiDataGrid-main .MuiOutlinedInput-notchedOutline': {
      border: '0 !important',
    },
  };
};

export const filterColumnsSx = () => {
  return {
    '& .MuiDataGrid-filterForm': {
      height: '35px',
      marginBottom: '0.5rem',
    },

    '& .MuiDataGrid-filterForm .MuiInput-underline.MuiInputBase-root': {
      marginTop: 0,
    },

    // Ensure pinned columns stay on top of other content
    '& .MuiDataGrid-columnHeader--pinnedLeft, & .MuiDataGrid-columnHeader--pinnedRight': {
      zIndex: 5,
    },
    '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
      zIndex: 4,
    },

    '& .MuiDataGrid-columnHeaderDraggableContainer': {
      flexGrow: 1,
    },
    '& .MuiDataGrid-menuIconButton': {
      position: 'absolute',
      right: 2,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 3,
    },

    // Position sort/filter icon container absolutely
    '& .MuiDataGrid-iconButtonContainer': {
      position: 'absolute',
      right: 2,
      top: '50%',
      transform: 'translateY(-50%)',
      marginLeft: 0,
      zIndex: 1,
      transition: 'right 0.2s',
      display: 'flex',
      alignItems: 'center',
      gap: '0px',
    },
    // Position sort container (no aria-label)
    '& .MuiDataGrid-iconButtonContainer:not([aria-label])': {
      right: 2,
    },
    // On hover move sort to make room for menu dots
    '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-iconButtonContainer:not([aria-label])': {
      right: 16,
    },
    // Position filter container (has aria-label) - only push left when sorted
    '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-iconButtonContainer[aria-label]': {
      right: 16,
    },
    // When not sorted, keep filter all the way to the right
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-iconButtonContainer[aria-label]': {
      right: 2,
    },
    // When hovering and sorted, push filter further left to also make room for menu dots
    '& .MuiDataGrid-columnHeader--sorted:hover .MuiDataGrid-iconButtonContainer[aria-label]': {
      right: 30,
    },
    // When hovering but not sorted, just move filter left for menu dots
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):hover .MuiDataGrid-iconButtonContainer[aria-label]':
      {
        right: 16,
      },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      position: 'relative',
      zIndex: 2,
    },

    // Sort icon visibility
    '& .MuiDataGrid-sortIcon': {
      opacity: 0,
      transition: 'opacity 0.2s',
    },
    // Ensure sort icon inside the container participates in flex flow
    '& .MuiDataGrid-iconButtonContainer .MuiDataGrid-sortIcon': {
      position: 'static',
    },
    '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon': {
      opacity: 1,
    },
    '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon': {
      opacity: 1,
    },
    // Hide sort icon when filtered but not sorted (even on hover)
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-columnHeader--filtered:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
      opacity: 0,
      display: 'none',
    },

    // Filter icon visibility (hidden by default, only shows when filtered)
    '& .MuiDataGrid-iconButtonContainer .MuiDataGrid-filterIcon': {
      display: 'none',
      position: 'static',
    },
    '& .MuiDataGrid-columnHeader--filtered .MuiDataGrid-iconButtonContainer .MuiDataGrid-filterIcon': {
      display: 'inline-flex',
      marginRight: '0px',
    },

    // Reserve space for sort icon when sorted (but not hovering)
    '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-columnHeaderTitleContainer': {
      paddingRight: '20px !important',
    },
    // Reserve space for filter icon when filtered but NOT sorted
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-columnHeaderTitleContainer:has(.MuiDataGrid-iconButtonContainer[aria-label])':
      {
        paddingRight: '20px !important',
      },
    // Reserve space for both when sorted AND filtered
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-columnHeaderTitleContainer:has(.MuiDataGrid-iconButtonContainer[aria-label])':
      {
        paddingRight: '32px !important',
      },
    // Reserve space on hover for menu dots
    '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-columnHeaderTitleContainer': {
      paddingRight: '30px !important',
    },
    // Reserve space on hover when only filtered (not sorted)
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):hover .MuiDataGrid-columnHeaderTitleContainer:has(.MuiDataGrid-iconButtonContainer[aria-label])':
      {
        paddingRight: '30px !important',
      },
    // Reserve space on hover when both sorted and filtered
    // eslint-disable-next-line max-len
    '& .MuiDataGrid-columnHeader--sorted:hover .MuiDataGrid-columnHeaderTitleContainer:has(.MuiDataGrid-iconButtonContainer[aria-label])':
      {
        paddingRight: '46px !important',
      },
  };
};
